import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printBankGuarantees = (user: User, grntid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getbankguaranteeconfreport",
		params: {
			userid: user.userId,
			grntid,
		},
	});
};

export default printBankGuarantees;
